export const throttle = 200;
export const duration = 2000;
